import React, {Component} from 'react';
import { connect } from 'react-redux';

class FilterBar extends Component {

    // Layout Column View
    LayoutView = (colSize) =>{
        if(!document.querySelector(".product-wrapper-grid").classList.contains("list-view")) {
            var elems = document.querySelector(".infinite-scroll-component .row").childNodes;
            [].forEach.call(elems, function(el) {
                el.className = '';
                el.classList.add('col-lg-'+colSize);
            });
        }
        this.props.onLayoutViewClicked(colSize);
    }

    render (){
        return (
            <div className="product-filter-content">
                {/* <div className="search-count">
                    <h5>Showing Products 1-{this.props.products.length} Result</h5>
                </div> */}
                <div className="collection-grid-view">
                    <ul>
                        <li>
                            <span className={"pr-2"}>See</span>
                        </li>
                        <li className={this.props.colSize === 3 ? 'opacity-3': ''}>
                            <span onClick={() => this.LayoutView(6)} style={{cursor: "pointer"}}>3</span>
                        </li>
                        <li>
                            <span className="pr-2 pl-2"  >|</span>
                        </li>
                        <li className={this.props.colSize === 6 ? 'opacity-3': ''}>
                            <span  onClick={() => this.LayoutView(3)} style={{cursor: "pointer"}}>4</span>
                        </li>
                    </ul>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    products: state.category.products
})

export default connect(mapStateToProps)(FilterBar);